module.exports = __webpack_public_path__ + "img/off-highway.a638196b.svg";